const patternCollections = [
  {
    id: 1,
    title: "Actions 5.5",
    title_fr: "Actions 5.5",
    title_en: "Actions 5.5",
    title_es: "Actions 5.5",

    description:
      "",
    coverSufarceId: 4,
    coverTextColor: "white"
  },
  {
    id: 2,
    title: "Collections 5.5",
    title_fr: "Collections 5.5",
    title_en: "Collections 5.5",
    title_es: "Collections 5.5",

    description:
      "",
    coverSufarceId: 2,
    coverTextColor: "white"
  },
  {
    id: 0,
    title: "Classiques",
    title_fr: "Classiques",
    title_en: "Classics",
    title_es: "Clásicos",

    description:
      "",
    coverSufarceId: 1,
    coverTextColor: "white"

  }
]

export const patternCollectionsByIds = patternCollections.reduce((acc, c) => {
  acc[c.id] = c
  return acc
}, {})

export default patternCollections



// WEBPACK FOOTER //
// ./src/constants/patternCollections.js